import { Button } from 'antd'
import React from 'react'
import { useDesignSystem } from '../../context/provider'

export const ThemeToggle: React.FC = () => {
  const { themeKey, setTheme } = useDesignSystem()

  const handleClick = () => {
    if (themeKey === 'dark') {
      setTheme('light')
    } else {
      setTheme('dark')
    }
  }

  return (
    <>
      <Button onClick={handleClick}>{themeKey}</Button>
    </>
  )
}
